import { useMutation } from '@tanstack/react-query';
import { IAccount } from '../../../extViewmodels';
import { useUserSession } from '../../../models/hooks/appStateHooks';

export interface IUpdateWebsiteUrlRequest {
	accountId: string;
	websiteUrl: string;
}

export function useAdminAccountWebsiteUrlMutation() {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: (request: IUpdateWebsiteUrlRequest) => {
			const encodedUrl = encodeURIComponent(request.websiteUrl || '');
			return userSession.webServiceHelper.callAsync<IAccount>(
				`admin/account/${request.accountId}/additionalInfo/websiteUrl?websiteUrl=${encodedUrl}`,
				'PUT'
			);
		},
	});
}
